import React, { useCallback, useState } from 'react';
import { GECKO_CONSTS, GeckoBtn, GeckoAlert } from 'ui';
import { initiateOAuth } from '../OAuth';

const SalesforceAuthorizationCodeField = ({ challengeValue, onSubmit }) => {
  const [error, setError] = useState(null);
  const authenticateWithSalesforce = useCallback(() => {
    return initiateOAuth(challengeValue).then(onSubmit).catch(setError);
  }, [challengeValue]);

  return (
    <div className="SalesforceAuthorizationCodeField gecko-field">
      {error ? (
        <GeckoAlert
          type="danger"
          aria-label="Submission errors"
          aria-live="assertive"
        >
          <ul>
            <li>{error}</li>
          </ul>
        </GeckoAlert>
      ) : null}
      <label className="control-label">Authenticate with Salesforce</label>
      <p className="description">
        Login and authenticate your Salesforce instance
      </p>
      <GeckoBtn
        name="Login"
        icon="fab fa-salesforce"
        type={GECKO_CONSTS.BTN_TYPE_PRIMARY}
        handler={authenticateWithSalesforce}
      />
    </div>
  );
};

export default SalesforceAuthorizationCodeField;
